<h3>
    <ng-content select="app-state-box-headline" />
</h3>
<p>
    <ng-content />
</p>

